export function getDefaultTerm(brand, key) {
    return 48;
}

export function getDefaultMileage(brand, key) {
    return 10000;
}

export function getDefaultDeposit(vehicle = {}, key) {
    if (typeof vehicle.age == 'undefined') {
        return 2315;
    }
    const age = new Number(vehicle.age);
    if (isNaN(age)) {
        return 2315;
    }
    if (age <= 3) {
        return 4000;
    }
    if (age <= 5) {
        return 3000;
    }
    if (age <= 7) {
        return 2000;
    }
    return 1000;
}

export default { getDefaultTerm, getDefaultMileage, getDefaultDeposit };